import { render, staticRenderFns } from "./homeProduct.vue?vue&type=template&id=483d6877"
import script from "./homeProduct.vue?vue&type=script&lang=js"
export * from "./homeProduct.vue?vue&type=script&lang=js"
import style0 from "./homeProduct.vue?vue&type=style&index=0&id=483d6877&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports